var element_zoom_map = "js-panzoom-main-menu";
var breakpoint_mobile_carte = 1000;

var largeur_ecran = window.outerWidth;

if(document.getElementById('js-panzoom-main-menu')){

    var img = new Image();
    var img_map = document.querySelector("#js-panzoom-canvas").src;
    
    img.onload = function() {
    
        document.querySelector("#js-panzoom-canvas").src = img_map;
        
        const elem = document.getElementById('js-panzoom-main-menu')
        
        const panzoom = Panzoom(elem, { 
            contain: 'outside', 
            startScale: largeur_ecran < breakpoint_mobile_carte ? 0.5 : 0.7,
            canvas: false,
            startX: largeur_ecran < breakpoint_mobile_carte ? -2912 : -1453,
            startY: largeur_ecran < breakpoint_mobile_carte ? -1415 : -1065
        })

        document.querySelector("#js-panzoom-canvas").classList.remove("hidden")
        document.querySelector(".game-main__map__pins").classList.remove("hidden")
        document.querySelector(".loader").classList.add("hidden")

    
    };
    
    img.src = img_map;
}

// Reset score
if(document.querySelector("#js-reset-score")){

    document.querySelector("#js-reset-score").addEventListener("click", function(e){
        e.preventDefault();

        sessionStorage.setItem("scores", JSON.stringify({}));
        window.location.href = "game-map.html";
    })
}

// window.alert(window.innerWidth + " x " + window.innerHeight)